module.exports = __webpack_public_path__ + "static/media/opt_pk_thumbnail.9cbfa4de.jpg";